export const helpCenterCourseAdapter = (data) => {
  return {
    sectionId: data.section.id,
    sectionCaption: data.section.caption,
    sectionSlug: data.section.slug,
    id: data.course.id,
    caption: data.course.caption,
    description: data.course.description,
    body: data.course.body,
    metaTitle: data.course.meta_title,
    metaDescription: data.course.meta_description,
    slug: data.course.slug,
    time: data.course.reading_time,
    views: data.course.page_views,
    articles: data.course.pages.articles?.map((i) => ({
      id: i.id,
      sectionSlug: data.course.pages_sections?.find((section) => section.id === i.section_id).slug,
      categorySlug: data.course.pages_subsections?.find((subsection) => subsection.id === i.subsection_id).slug,
      caption: i.caption,
      description: i.description,
      cover: i.cover,
      slug: i.slug,
      time: i.reading_time,
      bgcolor: i.bgcolor,
    })),
    videos: data.course.pages.videos?.map((i) => ({
      id: i.id,
      sectionSlug: data.course.pages_sections.find((section) => section.id === i.section_id).slug,
      categorySlug: data.course.pages_subsections?.find((subsection) => subsection.id === i.subsection_id).slug,
      caption: i.caption,
      cover: i.cover,
      slug: i.slug,
      time: i.reading_time,
      bgcolor: i.bgcolor,
    })),
    hotkeys: data.course.pages.hotkeys?.map((i) => ({
      id: i.id,
      sectionSlug: data.course.pages_sections?.find((section) => section.id === i.section_id).slug,
      categorySlug: data.course.pages_subsections?.find((subsection) => subsection.id === i.subsection_id).slug,
      caption: i.caption,
      description: i.description,
      cover: i.cover,
      slug: i.slug,
      time: i.reading_time,
      bgcolor: i.bgcolor,
    })),
    resources: data.course.resources?.map((i) => ({
      id: i.id,
      caption: i.caption,
      description: i.description,
      buttonTitle: i.button_title,
      buttonUrl: i.button_url,
    })),
  };
};
